/* eslint-disable max-len */
export class PostElementType {
    static list = [];
    static nameList = [];
    static map = {};
    options;
    name;
    title;
    description;
    isDeprecated;
    icon;
    maxAllowedElements;
    tabGroups;
    parallelGroups;
    propertiesList;
    properties;
    constructor(options) {
        this.options = options;
        this.name = options.name;
        this.title = options.title;
        this.description = options.description;
        this.icon = options.icon;
        this.isDeprecated = options.isDeprecated || false;
        this.maxAllowedElements = options.maxAllowedElements;
        this.tabGroups = options.tabGroups || [];
        this.parallelGroups = options.parallelGroups || [];
        this.propertiesList = options.propertiesList;
        this.properties = {};
        for (let i = 0; i < options.propertiesList.length; i++) {
            const property = options.propertiesList[i];
            this.properties[property.key] = property;
        }
        PostElementType.list.push(this);
        PostElementType.nameList.push(this.name);
        PostElementType.map[this.name] = this;
    }
}
const basicTabGroup = {
    group: "basic",
    title: "Basic settings",
    description: "Primary settings that are needed for this element.",
};
const extraTabGroup = {
    group: "extra",
    title: "Extra settings",
    description: "Additional settings that govern the style and functionality of this element.",
};
const LayerProperties = [
    {
        "key": "layerTag",
        "type": "list.list.string",
        "inputType": "dynamicOption",
        "showIfProperty": {
            "key": "contentType",
            "value": ["posts"],
        },
        "maxTags": 1,
        "group": "layerGroup",
        "tabGroup": "basic",
        "default": [[]],
        "defaultInsert": [],
        "title": "Page tag",
        "description": "Choose the page tag that determines which pages to include in this layer. You need to add this tag to all pages that you wish to appear on the map. You can use a public tag (with # prefix) or a private tag (no # prefix).",
        "multilingual": true,
    }, {
        "key": "layerCategory",
        "type": "list.list.string",
        "inputType": "dynamicOption",
        "showIfProperty": {
            "key": "contentType",
            "value": ["ideas", "proposals"],
        },
        "maxTags": 1,
        "group": "layerGroup",
        "tabGroup": "basic",
        "default": [[]],
        "defaultInsert": [],
        "title": "Thematic category",
        "description": "Choose the thematic category that determines which project ideas or proposals will be included in this layer.",
        "multilingual": true,
    }, {
        "key": "markerColor",
        "type": "list.string",
        "inputType": "color",
        "group": "layerGroup",
        "tabGroup": "basic",
        "default": [""],
        "defaultInsert": "",
        "title": "Marker color",
        "description": "The color to use for the map marker. Use the color selector or specify a hex value.",
        "multilingual": false,
        "autoFill": "palette",
    }, {
        "key": "darkTextColor",
        "type": "list.boolean",
        "group": "layerGroup",
        "tabGroup": "basic",
        "inputType": "switch",
        "default": [false],
        "defaultInsert": false,
        "title": "Dark icon",
        "description": "Use a dark icon for the marker.",
        "multilingual": false,
    }, {
        "key": "invertColors",
        "type": "list.boolean",
        "group": "layerGroup",
        "tabGroup": "basic",
        "inputType": "switch",
        "default": [false],
        "defaultInsert": false,
        "title": "Invert colors",
        "description": "Switch the marker color and the icon color.",
        "multilingual": false,
    }, {
        "key": "icon",
        "type": "list.list.string",
        "inputType": "iconOption",
        "group": "layerGroup",
        "tabGroup": "basic",
        "default": [[]],
        "defaultInsert": [],
        "title": "Icon",
        "description": "Icon to show in the marker. See <a href='https://fontawesome.com/icons' target='_blank'>Font Awesome</a> for supported icons.",
        "multilingual": false,
    }, {
        "key": "iconClass",
        "type": "list.string",
        "inputType": "iconClassOption",
        "group": "layerGroup",
        "tabGroup": "basic",
        "default": ["fal"],
        "defaultInsert": "fal",
        "title": "Icon weight",
        "description": "The weight (light, regular, bold) to use for the icon.",
        "multilingual": false,
    }
];
const parentElementId = {
    "key": "parentElementId",
    "type": "string",
    "group": "content",
    "tabGroup": "basic",
    "default": null,
    "hiddenFromInterface": true,
    "multilingual": false,
};
export const header = new PostElementType({
    name: "header",
    icon: ["fal", "heading"],
    title: "Header",
    description: "A text header",
    tabGroups: [basicTabGroup],
    propertiesList: [{
            "key": "text",
            "type": "string",
            "inputType": "text",
            "group": "content",
            "tabGroup": "basic",
            "default": null,
            "title": "Header text",
            "description": "This is the text which appears in the header.",
            "multilingual": true,
        }, {
            "key": "size",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["1", "2", "3", "4"],
            "valueOptionIcons": ["h1", "h2", "h3", "h4"],
            "group": "style",
            "tabGroup": "basic",
            "default": "2",
            "title": "Header size",
            "description": "The header size class to use.",
            "multilingual": false,
        }, {
            "key": "class",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["title", "subtitle"],
            "valueOptionTexts": ["Title", "Subtitle"],
            "group": "style",
            "tabGroup": "basic",
            "default": "title",
            "title": "Header style",
            "description": "The header style class to use.",
            "multilingual": false,
        }, {
            "key": "align",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["left", "center", "right"],
            "valueOptionIcons": ["align-left", "align-center", "align-right"],
            "group": "style",
            "tabGroup": "basic",
            "default": "left",
            "title": "Alignment",
            "description": "How to align (left, center, right) the header.",
            "multilingual": false,
        },
        parentElementId,
    ],
});
export const paragraph = new PostElementType({
    name: "paragraph",
    icon: ["fal", "paragraph"],
    title: "Paragraph",
    description: "A paragraph of text.",
    tabGroups: [basicTabGroup],
    propertiesList: [{
            "key": "text",
            "type": "string",
            "inputType": "textarea",
            "group": "content",
            "tabGroup": "basic",
            "default": null,
            "title": "Paragraph content",
            "description": "This is the text which appears in the paragraph.",
            "multilingual": true,
        }, {
            "key": "size",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["small", "", "medium", "large"],
            "valueOptionTexts": ["Small", "Normal", "Medium", "Large"],
            "group": "style",
            "tabGroup": "basic",
            "default": "",
            "title": "Text size",
            "description": "The text size class to use.",
            "multilingual": false,
        }, {
            "key": "align",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["left", "center", "right"],
            "valueOptionIcons": ["align-left", "align-center", "align-right"],
            "group": "style",
            "tabGroup": "basic",
            "default": "left",
            "title": "Alignment",
            "description": "How to align (left, center, right) the paragraph.",
            "multilingual": false,
        }, {
            "key": "contentType",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["raw", "markdown"],
            "valueOptionTexts": ["Plain text", "Markdown"],
            "group": "style",
            "tabGroup": "basic",
            "default": "markdown",
            "title": "Formatting",
            "description": "What format to display the text as. Markdown allows you to create simple styling for lists, URL's and emphasizing text.",
            "multilingual": false,
        },
        parentElementId,
    ],
});
export const spacer = new PostElementType({
    name: "spacer",
    icon: ["fal", "expand-wide"],
    title: "Spacer",
    description: "A vertical spacer",
    tabGroups: [basicTabGroup],
    propertiesList: [{
            "key": "height",
            "type": "number",
            "inputType": "integer",
            "group": "style",
            "tabGroup": "basic",
            "default": 20,
            "title": "Spacer height",
            "description": "This is the height in pixels of the spacer.",
            "multilingual": true,
        }, {
            "key": "showRule",
            "type": "boolean",
            "inputType": "checkbox",
            "group": "style",
            "tabGroup": "basic",
            "default": false,
            "title": "Show horizontal rule",
            "description": "Whether to show a horizontal rule.",
            "multilingual": false,
        }, {
            "key": "ruleThickness",
            "type": "number",
            "inputType": "integer",
            "group": "style",
            "tabGroup": "basic",
            "default": 1,
            "title": "Rule thickness",
            "description": "This is the thickness in pixels of the rule.",
            "multilingual": false,
        }, {
            "key": "ruleWidth",
            "type": "number",
            "inputType": "slider",
            "group": "style",
            "tabGroup": "basic",
            "default": 100,
            "format": "percent",
            "limits": [0, 100],
            "step": 1,
            "ticks": [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
            "title": "Rule width",
            "description": "The width in percent of the rule.",
            "multilingual": false,
        }, {
            "key": "ruleColor",
            "type": "string",
            "inputType": "color",
            "group": "style",
            "tabGroup": "basic",
            "default": "#000000",
            "title": "Rule color",
            "description": "The color to use for the rule. Use the color selector or specify a hex value.",
            "multilingual": false,
        }, {
            "key": "ruleStyle",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["solid", "dashed", "dotted", "double"],
            "valueOptionTexts": ["Solid", "Dashed", "Dotted", "Double"],
            "group": "style",
            "tabGroup": "basic",
            "default": "solid",
            "title": "Rule style",
            "description": "The style for drawing the rule.",
            "multilingual": false,
        },
        parentElementId,
    ],
});
export const iframe = new PostElementType({
    name: "iframe",
    icon: ["fal", "browser"],
    title: "Iframe",
    description: "An iframe element for embedding web content in the page.",
    tabGroups: [basicTabGroup, extraTabGroup],
    propertiesList: [{
            "key": "href",
            "type": "string",
            "inputType": "url",
            "group": "content",
            "tabGroup": "basic",
            "default": "",
            "title": "Iframe URL",
            "description": "The URL of the page that you want to embed.",
            "multilingual": true,
        }, {
            "key": "isFullWidth",
            "type": "boolean",
            "inputType": "switch",
            "group": "content",
            "tabGroup": "extra",
            "default": false,
            "title": "Use full width",
            "description": "Use the full width of the page for the iframe.",
            "multilingual": false,
        }, {
            "key": "height",
            "type": "number",
            "inputType": "integer",
            "group": "content",
            "tabGroup": "extra",
            "default": 600,
            "title": "Height",
            "description": "Set the height of the iframe element.",
            "multilingual": false,
        }],
});
export const link = new PostElementType({
    name: "link",
    icon: ["fal", "external-link-alt"],
    title: "Hyperlink",
    description: "A web hyperlink.",
    tabGroups: [basicTabGroup],
    propertiesList: [{
            "key": "title",
            "type": "string",
            "inputType": "text",
            "group": "content",
            "tabGroup": "basic",
            "default": "",
            "title": "Link title",
            "description": "Title text to show with the link.",
            "multilingual": true,
        }, {
            "key": "href",
            "type": "string",
            "inputType": "text",
            "group": "content",
            "tabGroup": "basic",
            "default": "",
            "title": "Link URL",
            "description": "Link destination URL.",
            "multilingual": true,
        },
        parentElementId,
    ],
});
export const qlink = new PostElementType({
    name: "qlink",
    icon: ["fal", "map-marker-question"],
    title: "Questionnaire link",
    description: "A link to a questionnaire",
    tabGroups: [basicTabGroup],
    propertiesList: [{
            "key": "questionnaireId",
            "type": "resourceId",
            "isResourceId": "questionnaire",
            "inputType": "questionnaireId",
            "group": "functional",
            "tabGroup": "basic",
            "default": null,
            "title": "Questionnaire",
            "description": "Search for the questionnaire by name.",
            "multilingual": false,
        }, {
            "key": "questionnaireLanguage",
            "type": "string",
            "inputType": "languageOption",
            "group": "functional",
            "tabGroup": "basic",
            "default": null,
            "title": "Questionnaire language",
            "description": "Select the questionnaire language.",
            "multilingual": false,
        },
        parentElementId,
    ],
});
export const plink = new PostElementType({
    name: "plink",
    icon: ["fal", "pager"],
    title: "Post link",
    description: "A link to a post page",
    tabGroups: [basicTabGroup],
    propertiesList: [{
            "key": "postId",
            "type": "resourceId",
            "isResourceId": "post",
            "inputType": "postId",
            "group": "functional",
            "tabGroup": "basic",
            "default": null,
            "title": "Post page",
            "description": "Search for the post page by name",
            "multilingual": false,
        },
        parentElementId,
    ],
});
export const postMenu = new PostElementType({
    name: "postMenu",
    icon: ["fal", "pager"],
    title: "Pages menu",
    description: "A menu with links to pages",
    tabGroups: [basicTabGroup],
    maxAllowedElements: 1,
    parallelGroups: [{
            group: "postsGroup",
            title: "Pages",
            description: "The pages to show in the menu.",
            labelPropertyName: "postIdList",
            tabGroups: [basicTabGroup],
            tabGroup: "basic",
        }],
    propertiesList: [{
            "key": "imageAssetId",
            "type": "resourceId",
            "isResourceId": "asset",
            "inputType": "imageAssetId",
            "group": "content",
            "tabGroup": "basic",
            "default": null,
            "title": "Logo",
            "description": "Choose an image to display inside the menu.",
            "multilingual": true,
        }, {
            "key": "postIdList",
            "type": "list.resourceId",
            "isResourceId": "post",
            "inputType": "postId",
            "group": "postsGroup",
            "tabGroup": "basic",
            "default": [""],
            "defaultInsert": "",
            "title": "Page",
            "description": "Search by internal title. The page's public title will show in the menu.",
            "multilingual": false,
        }],
});
export const timeline = new PostElementType({
    name: "timeline",
    icon: ["fal", "calendar-times"],
    title: "Timeline",
    description: "A list of dates and descriptions.",
    tabGroups: [basicTabGroup, extraTabGroup],
    parallelGroups: [{
            group: "eventGroup",
            title: "Events",
            description: "The events that appear in this timeline.",
            labelPropertyName: "eventTitleList",
            tabGroups: [basicTabGroup, extraTabGroup],
            tabGroup: "basic",
        }],
    propertiesList: [{
            "key": "title",
            "type": "string",
            "inputType": "text",
            "group": "content",
            "tabGroup": "basic",
            "default": "",
            "title": "Timeline title",
            "description": "Title text to identify the purpose of the timeline.",
            "multilingual": true,
        }, {
            "key": "timelineColor",
            "type": "string",
            "inputType": "color",
            "group": "style",
            "tabGroup": "basic",
            "default": "#ED7F50",
            "title": "Timeline color",
            "description": "The color to use for timeline element. Use the color selector or specify a hex value.",
            "multilingual": false,
        }, {
            "key": "size",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["small", "", "medium", "large"],
            "valueOptionTexts": ["Small", "Normal", "Medium", "Large"],
            "group": "style",
            "tabGroup": "extra",
            "default": "",
            "title": "Text size",
            "description": "The text size class to use.",
            "multilingual": false,
        }, {
            "key": "align",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["left", "center", "right"],
            "valueOptionIcons": ["align-left", "align-center", "align-right"],
            "group": "style",
            "tabGroup": "extra",
            "default": "left",
            "title": "Alignment for vertical timeline",
            "description": "How to align (left, center, right) the paragraph.",
            "multilingual": false,
        }, /* {
            "key": "dateGranularity",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["minute", "day", "month"],
            "valueOptionTexts": ["Minute", "Day", "Month"],
            "group": "content",
            "tabGroup": "",
            "default": "minute",
            "title": "Date granularity setting",
            "description": "Display dates which are precise to the minute, day, or month.",
        }, */
        {
            "key": "titleOnTop",
            "type": "boolean",
            "inputType": "switch",
            "group": "content",
            "tabGroup": "extra",
            "default": true,
            "title": "Show title on top",
            "description": "Show item's titles in the headline and the date in smaller font below it.",
            "multilingual": false,
        }, {
            "key": "sortByStartDate",
            "type": "boolean",
            "inputType": "switch",
            "group": "content",
            "tabGroup": "extra",
            "default": true,
            "title": "Sort by start date",
            "description": "Sort the displayed list according to event start dates.",
            "multilingual": false,
        }, {
            "key": "showTimezone",
            "type": "boolean",
            "inputType": "switch",
            "group": "content",
            "tabGroup": "extra",
            "default": null,
            "title": "Show timezone",
            "description": "Prefer displaying dates in this timezone. Leave blank to use the visitor's local timezone.",
            "multilingual": false,
        }, {
            "key": "timezone",
            "type": "list.string",
            "inputType": "timezoneOption",
            "group": "content",
            "tabGroup": "extra",
            "default": [],
            "title": "Timezone",
            "description": "Prefer displaying dates in this timezone. Leave blank to use the visitor's local timezone.",
            "multilingual": false,
        }, {
            "key": "eventTitleList",
            "type": "list.string",
            "inputType": "text",
            "group": "eventGroup",
            "tabGroup": "basic",
            "default": [""],
            "defaultInsert": "",
            "title": "Event title",
            "description": "The title for this event.",
            "multilingual": true,
        }, {
            "key": "eventDescriptionList",
            "type": "list.string",
            "inputType": "textarea",
            "native.rows": 4,
            "group": "eventGroup",
            "tabGroup": "basic",
            "default": [""],
            "defaultInsert": "",
            "title": "Event description",
            "description": "The description for this event.",
            "multilingual": true,
        }, {
            "key": "eventDateGranularityList",
            "type": "list.string",
            "inputType": "ownOption",
            "valueOptions": ["minute", "day", "month"],
            "valueOptionTexts": ["Minute", "Day", "Month"],
            "group": "eventGroup",
            "tabGroup": "extra",
            "default": ["minute"],
            "defaultInsert": "minute",
            "title": "Date granularity setting",
            "description": "Display dates which are precise to the minute, day, or month.",
            "multilingual": false,
        }, {
            "key": "eventStartDateList",
            "type": "list.date",
            "inputType": "dateTimeLocal",
            "group": "eventGroup",
            "tabGroup": "basic",
            "default": [""],
            "defaultInsert": "",
            "autoFill": "dateNow",
            "title": "Event start",
            "description": "The date and time when this event begins.",
            "multilingual": false,
        }, {
            "key": "eventShowEndDateList",
            "type": "list.boolean",
            "inputType": "switch",
            "group": "eventGroup",
            "tabGroup": "extra",
            "default": [false],
            "defaultInsert": false,
            "title": "Show event duration",
            "description": "Show event duration if this event has an end date or time.",
            "multilingual": false,
        }, {
            "key": "eventEndDateList",
            "type": "list.date",
            "inputType": "dateTimeLocal",
            "group": "eventGroup",
            "tabGroup": "extra",
            "default": [""],
            "defaultInsert": "",
            "autoFill": "dateNow",
            "title": "Event end",
            "description": "The date and time when this event ends.",
            "multilingual": false,
        }, {
            "key": "eventContentTypeList",
            "type": "list.string",
            "inputType": "ownOption",
            "valueOptions": ["raw", "markdown"],
            "valueOptionTexts": ["Plain text", "Markdown"],
            "group": "eventGroup",
            "tabGroup": "extra",
            "default": ["raw"],
            "defaultInsert": "raw",
            "title": "Formatting",
            "description": "What format to display the event description as. Markdown allows you to create simple styling for lists, URL's and emphasizing text.",
            "multilingual": false,
        }, {
            "key": "eventLinkUrlList",
            "type": "list.string",
            "inputType": "url",
            "group": "eventGroup",
            "tabGroup": "extra",
            "default": [""],
            "defaultInsert": "",
            "title": "Event link",
            "description": "Add URL link to the event",
            "multilingual": true,
        }, {
            "key": "disableTimelineProgress",
            "type": "boolean",
            "inputType": "switch",
            "group": "content",
            "tabGroup": "extra",
            "default": false,
            "title": "Disable timeline progress",
            "description": "Don’t show timeline progress.",
            "multilingual": false,
        }, {
            "key": "isHorizontal",
            "type": "boolean",
            "inputType": "switch",
            "group": "content",
            "tabGroup": "extra",
            "default": false,
            "title": "Make timeline horizontal",
            "description": "Makes the timeline direction horizontal. Does not effect on mobile view.",
            "multilingual": false,
        }, {
            "key": "buttonLabels",
            "type": "boolean",
            "inputType": "switch",
            "group": "content",
            "tabGroup": "extra",
            "default": false,
            "title": "Convert title to button.",
            "description": "Converts the title to a button for adding a link.",
            "multilingual": false,
        }, {
            "key": "indexedPoints",
            "type": "boolean",
            "inputType": "switch",
            "group": "content",
            "tabGroup": "extra",
            "default": false,
            "title": "Indexed points",
            "description": "Add numbers to event point dots.",
            "multilingual": false,
        }, {
            "key": "hidePointer",
            "type": "boolean",
            "inputType": "switch",
            "group": "content",
            "tabGroup": "extra",
            "default": false,
            "title": "Hide pointer",
            "description": "Hides the pointer that shows the upcoming event.",
            "multilingual": false,
        }, {
            "key": "hasDropletBackground",
            "type": "boolean",
            "inputType": "switch",
            "group": "content",
            "tabGroup": "extra",
            "default": false,
            "title": "Droplet background",
            "description": "Give the event pointer icon a droplet background.",
            "multilingual": false,
        }, {
            "key": "icon",
            "type": "list.string",
            "inputType": "iconOption",
            "group": "style",
            "tabGroup": "extra",
            "default": null,
            "title": "Icon",
            "description": "Icon to show in the event pointer. See <a href='https://fontawesome.com/icons' target='_blank'>Font Awesome</a> for supported icons.",
            "multilingual": false,
        }, {
            "key": "iconClass",
            "type": "string",
            "inputType": "iconClassOption",
            "group": "style",
            "tabGroup": "extra",
            "default": "fal",
            "title": "Icon weight",
            "description": "The weight (light, regular, bold) to use for the icon.",
            "multilingual": false,
        }, {
            "key": "iconColor",
            "type": "string",
            "inputType": "color",
            "group": "style",
            "tabGroup": "extra",
            "default": "#ED7F50",
            "title": "Icon color",
            "description": "The color to use for the icon. Use the color selector or specify a hex value.",
            "multilingual": false,
        }, {
            "key": "darkTextColor",
            "type": "boolean",
            "group": "style",
            "tabGroup": "extra",
            "inputType": "switch",
            "default": false,
            "title": "Dark icon color",
            "description": "Use a dark icon color for the button text.",
            "multilingual": false,
        }, {
            "key": "invertColors",
            "type": "boolean",
            "group": "style",
            "tabGroup": "extra",
            "inputType": "switch",
            "default": false,
            "title": "Invert colors",
            "description": "Switch the button color and the text color.",
            "multilingual": false,
        },
        parentElementId,
    ],
});
export const image = new PostElementType({
    name: "image",
    icon: ["fal", "image"],
    title: "Image",
    description: "Image",
    tabGroups: [basicTabGroup, extraTabGroup],
    propertiesList: [{
            "key": "imageAssetId",
            "type": "resourceId",
            "isResourceId": "asset",
            "inputType": "imageAssetId",
            "group": "functional",
            "tabGroup": "basic",
            "default": null,
            "title": "Image asset",
            "description": "An asset to use when displaying this image.",
            "multilingual": true,
        }, {
            // DEPRECIATED
            // DEPRECIATED
            "key": "imageUrl",
            "type": "url",
            "inputType": "imageUrl",
            "group": "functional",
            "tabGroup": "basic",
            "default": null,
            "title": "Image url",
            "description": "The url of the image to display.",
            "hiddenFromInterface": true,
            // DEPRECIATED
            // DEPRECIATED
        }, {
            "key": "showAttribution",
            "type": "boolean",
            "inputType": "switch",
            "group": "style",
            "tabGroup": "extra",
            "default": false,
            "title": "Show attribution",
            "description": "Show the image asset's attribution.",
            "multilingual": false,
        }, {
            "key": "title",
            "type": "string",
            "inputType": "text",
            "group": "content",
            "tabGroup": "extra",
            "default": null,
            "title": "Title",
            "description": "A title to display above the image.",
            "multilingual": true,
        }, {
            "key": "titleSize",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["small", "", "medium", "large"],
            "valueOptionTexts": ["Small", "Normal", "Medium", "Large"],
            "group": "style",
            "tabGroup": "extra",
            "default": "",
            "title": "Title text size",
            "description": "The text size class to use for the title.",
            "multilingual": false,
        }, {
            "key": "titleAlign",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["left", "center", "right"],
            "valueOptionIcons": ["align-left", "align-center", "align-right"],
            "group": "style",
            "tabGroup": "extra",
            "default": "left",
            "title": "Title alignment",
            "description": "How to align (left, center, right) the title.",
            "multilingual": false,
        }, {
            "key": "imageAlignment",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["left", "center", "right"],
            "valueOptionIcons": ["align-left", "align-center", "align-right"],
            "group": "style",
            "tabGroup": "basic",
            "default": "center",
            "title": "Image alignment",
            "description": "How to align the image (left, center, right) when the image is narrower than the page width and there is no caption text next to the image.",
            "multilingual": false,
        }, {
            "key": "imageWidth",
            "type": "number",
            "inputType": "slider",
            "group": "style",
            "tabGroup": "basic",
            "default": 100,
            "format": "percent",
            "limits": [0, 100],
            "step": 1,
            "title": "Image width",
            "description": "Choose how much space the image should take up as a percentage of page width. If you have caption text next to the image, the maximum width of the image is limited to 70%. If you set this to zero, the image will not be scaled up.",
            "multilingual": false,
        }, {
            "key": "caption",
            "type": "string",
            "inputType": "textarea",
            "native.rows": 4,
            "group": "content",
            "tabGroup": "extra",
            "default": null,
            "title": "Caption",
            "description": "A caption to display next to the image.",
            "multilingual": true,
        }, {
            "key": "captionSize",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["small", "", "medium", "large"],
            "valueOptionTexts": ["Small", "Normal", "Medium", "Large"],
            "group": "style",
            "tabGroup": "extra",
            "default": "",
            "title": "Caption size",
            "description": "The text size class to use for the caption text.",
            "multilingual": false,
        }, {
            "key": "captionAlignment",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["left", "center", "right"],
            "valueOptionIcons": ["align-left", "align-center", "align-right"],
            "group": "style",
            "tabGroup": "extra",
            "default": "left",
            "title": "Caption text alignment",
            "description": "How to align (left, center, right) the caption text.",
            "multilingual": false,
        }, {
            "key": "captionPlacement",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["left", "below", "right"],
            "valueOptionTexts": ["Left", "Below", "Right"],
            "group": "style",
            "tabGroup": "extra",
            "default": "below",
            "title": "Caption placement",
            "description": "Place the caption to the left of, to the right of, or below the image.",
            "multilingual": false,
        }, {
            "key": "verticalAlignment",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["flex-start", "center", "flex-end"],
            "valueOptionIcons": ["arrow-to-top", "horizontal-rule", "arrow-to-bottom"],
            "group": "style",
            "tabGroup": "extra",
            "default": "flex-start",
            "title": "Vertical alignment",
            "description": "How to align the image and caption (top, center, bottom) when the caption is next to the image.",
            "multilingual": false,
        },
        parentElementId,
    ],
});
export const heroImage = new PostElementType({
    name: "heroImage",
    icon: ["fal", "image"],
    title: "Hero Image",
    description: "A full page width image",
    tabGroups: [basicTabGroup, extraTabGroup],
    propertiesList: [{
            "key": "imageAssetId",
            "type": "resourceId",
            "isResourceId": "asset",
            "inputType": "imageAssetId",
            "group": "functional",
            "tabGroup": "basic",
            "default": null,
            "title": "Image asset",
            "description": "An asset to use when displaying this image.",
            "multilingual": true,
        }, {
            // DEPRECIATED
            // DEPRECIATED
            "key": "imageUrl",
            "type": "url",
            "inputType": "imageUrl",
            "group": "functional",
            "tabGroup": "basic",
            "default": null,
            "title": "Image url",
            "description": "The url of the image to display.",
            "hiddenFromInterface": true,
            // DEPRECIATED
            // DEPRECIATED
        }, {
            "key": "title",
            "type": "string",
            "inputType": "text",
            "group": "content",
            "tabGroup": "extra",
            "default": null,
            "title": "Title",
            "description": "A title to display above the image.",
            "multilingual": true,
        }, {
            "key": "backgroundOverlay",
            "type": "boolean",
            "inputType": "switch",
            "group": "style",
            "tabGroup": "extra",
            "default": false,
            "title": "Background overlay",
            "description": "Make the background have a dark overlay",
            "multilingual": false,
        }, {
            "key": "titleColor",
            "type": "boolean",
            "inputType": "switch",
            "group": "style",
            "tabGroup": "extra",
            "default": false,
            "title": "Choose title color",
            "description": "Makes title color dark or light",
            "multilingual": false,
        }, {
            "key": "fontSize",
            "type": "number",
            "inputType": "slider",
            "group": "style",
            "tabGroup": "extra",
            "default": 36,
            "limits": [36, 156],
            "step": 1,
            "ticks": [36, 48, 66, 90, 120, 156],
            "title": "Choose font size",
            "description": "Choose the titles font size",
            "multilingual": false,
        }, {
            "key": "height",
            "type": "number",
            "inputType": "slider",
            "group": "style",
            "tabGroup": "extra",
            "default": 0,
            "limits": [0, 100],
            "title": "Image height",
            "description": "This is the height of the image, as a percentage of the page height. If this setting is set to 0, then the height of the image in pixels will be used.",
            "multilingual": true,
        }],
});
export const savedChartElement = new PostElementType({
    name: "savedChartElement",
    icon: ["fal", "chart-bar"],
    title: "Chart element",
    description: "Chart element",
    tabGroups: [basicTabGroup],
    propertiesList: [{
            "key": "questionnaireId",
            "type": "resourceId",
            "isResourceId": "questionnaire",
            "inputType": "questionnaireId",
            "group": "functional",
            "tabGroup": "basic",
            "default": null,
            "title": "Questionnaire",
            "description": "Search for the questionnaire by name for which you want to display a chart.",
            "multilingual": false,
        }, {
            "key": "chartId",
            "type": "resourceId",
            "isResourceId": "chart",
            "inputType": "chartId",
            "group": "functional",
            "tabGroup": "basic",
            "default": null,
            "title": "Chart",
            "description": "Select a chart that you have saved in the questionnaire's analysis page.",
            "multilingual": false,
        }, {
            "key": "chartData",
            "hiddenFromInterface": true,
            "type": "object",
            "inputType": "text",
            "group": "functional",
            "tabGroup": "basic",
            "default": {},
        },
        parentElementId,
    ],
});
export const heroCombo = new PostElementType({
    name: "heroCombo",
    icon: ["fal", "objects-column"],
    title: "Hero",
    description: "A full page width image or map with additional elements.",
    tabGroups: [basicTabGroup],
    propertiesList: [
        ...savedChartElement.propertiesList.filter((prop) => prop.key !== "parentElementId"),
        {
            "key": "imageAssetId",
            "type": "resourceId",
            "isResourceId": "asset",
            "inputType": "imageAssetId",
            "group": "functional",
            "tabGroup": "basic",
            "default": null,
            "title": "Image asset",
            "description": "An asset to use when displaying this image.",
            "multilingual": true,
        }, {
            "key": "contentShape",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["column", "box"],
            "valueOptionTexts": ["Column", "Box"],
            "group": "style",
            "tabGroup": "basic",
            "default": "column",
            "title": "Content shape",
            "description": "Column will be placed next to the media, box will be placed on top.",
            "multilingual": false,
        }, {
            "key": "mainContentType",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["image", "chart"],
            "valueOptionTexts": ["Image", "Chart"],
            "group": "style",
            "tabGroup": "basic",
            "default": "image",
            "title": "Main content type",
            "description": "Choose whether the main content is an image, chart, or other media.",
            "multilingual": false,
        }, {
            "key": "contentAlignment",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["left", "right"],
            "valueOptionTexts": ["Left", "Right"],
            "group": "style",
            "tabGroup": "basic",
            "default": "left",
            "title": "Content alignment",
            "description": "Where to align the content.",
            "multilingual": false,
            "showIfProperty": {
                "key": "contentShape",
                "value": ["column"],
            },
        }, {
            "key": "contentAlignmentBox",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["left", "center", "right"],
            "valueOptionTexts": ["Left", "Center", "Right"],
            "group": "style",
            "tabGroup": "basic",
            "default": "left",
            "title": "Content alignment",
            "description": "Where to align the content.",
            "multilingual": false,
            "showIfProperty": {
                "key": "contentShape",
                "value": ["box"],
            },
        }, {
            "key": "contentWidth",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["half", "narrow", "wide"],
            "valueOptionTexts": ["Half", "Narrow", "Wide"],
            "group": "style",
            "tabGroup": "basic",
            "default": "half",
            "title": "Content width",
            "description": "How wide the content should be.",
            "multilingual": false,
        }, {
            "key": "isOpeningImageAllowed",
            "type": "boolean",
            "inputType": "switch",
            "group": "style",
            "tabGroup": "basic",
            "default": false,
            "title": "Click image to view",
            "description": "The image will be opened in a full screen modal when clicked.",
            "multilingual": false,
        }, {
            "key": "isImageFullyShown",
            "type": "boolean",
            "inputType": "switch",
            "group": "style",
            "tabGroup": "basic",
            "default": false,
            "title": "Fit the full image inside the sidebar",
            "description": "Enable this if you always want the full image to show (use this if the image contains information which should not be cut off on certain screensizes).",
            "multilingual": false,
            "showIfProperty": {
                "key": "contentShape",
                "value": ["column"],
            },
        }, {
            "key": "analysisMapSettings",
            "hiddenFromInterface": true,
            "type": "object",
            "inputType": "text",
            "group": "functional",
            "tabGroup": "basic",
            "default": {},
        },
    ],
});
export const audio = new PostElementType({
    name: "audio",
    icon: ["fal", "music"],
    title: "Audio",
    description: "Audio",
    tabGroups: [basicTabGroup, extraTabGroup],
    propertiesList: [{
            "key": "audioAssetId",
            "type": "resourceId",
            "isResourceId": "asset",
            "inputType": "audioAssetId",
            "group": "content",
            "tabGroup": "basic",
            "default": null,
            "title": "Audio asset",
            "description": "The audio asset to play in this audio player.",
            "multilingual": true,
        }, {
            "key": "showAttribution",
            "type": "boolean",
            "inputType": "switch",
            "group": "style",
            "tabGroup": "extra",
            "default": false,
            "title": "Show attribution",
            "description": "Show the audio asset's attribution.",
            "multilingual": false,
        },
        parentElementId,
    ],
});
export const youtube = new PostElementType({
    name: "youtube",
    icon: ["fab", "youtube-square"],
    title: "Youtube video",
    description: "Youtube video",
    tabGroups: [basicTabGroup, extraTabGroup],
    propertiesList: [{
            "key": "videoUrl",
            "type": "url",
            "inputType": "videoUrl",
            "group": "functional",
            "tabGroup": "basic",
            "default": null,
            "title": "Video url",
            "description": "The url of the video to display.",
            "multilingual": true,
        }, {
            "key": "showCaptions",
            "type": "boolean",
            "group": "functional",
            "tabGroup": "extra",
            "inputType": "switch",
            "default": false,
            "title": "Show captions",
            "description": "Automatically show captions for the video if available.",
            "multilingual": false,
        }, {
            "key": "captionLocale",
            "type": "string",
            "inputType": "languageOption",
            "group": "functional",
            "tabGroup": "extra",
            "default": null,
            "title": "Caption language",
            "description": "Which language should the captions be in. Leave this blank to use the users currently selected language.",
            "multilingual": true,
        }, {
            // DEPRECIATED
            // DEPRECIATED
            "key": "titleText",
            "type": "string",
            "inputType": "text",
            "group": "content",
            "tabGroup": "basic",
            "default": null,
            "title": "Video title text",
            "description": "A brief text summary of the video.",
            "hiddenFromInterface": true,
            // DEPRECIATED
            // DEPRECIATED
        },
        parentElementId,
    ],
});
export const vimeo = new PostElementType({
    name: "vimeo",
    icon: ["fab", "vimeo-square"],
    title: "Vimeo video",
    description: "Vimeo video",
    tabGroups: [basicTabGroup, extraTabGroup],
    propertiesList: [{
            "key": "videoId",
            "type": "string",
            "inputType": "text",
            "group": "functional",
            "tabGroup": "basic",
            "default": null,
            "title": "Video ID",
            "description": "The ID of the video to display.",
            "multilingual": true,
        }, {
            "key": "showCaptions",
            "type": "boolean",
            "group": "functional",
            "tabGroup": "extra",
            "inputType": "switch",
            "default": false,
            "title": "Show captions",
            "description": "Automatically show captions for the video if available.",
            "multilingual": false,
        }, {
            "key": "captionLocale",
            "type": "string",
            "inputType": "languageOption",
            "group": "functional",
            "tabGroup": "extra",
            "default": null,
            "title": "Caption language",
            "description": "Which language should the captions be in. Leave this blank to use the users currently selected language.",
            "multilingual": true,
        }, {
            // DEPRECIATED
            // DEPRECIATED
            "key": "titleText",
            "type": "string",
            "inputType": "text",
            "group": "content",
            "tabGroup": "basic",
            "default": null,
            "title": "Video title text",
            "description": "A brief text summary of the video.",
            "hiddenFromInterface": true,
            // DEPRECIATED
            // DEPRECIATED
        },
        parentElementId,
    ],
});
export const fileDownload = new PostElementType({
    name: "fileDownload",
    icon: ["fal", "arrow-alt-down"],
    title: "file download",
    description: "file download",
    tabGroups: [basicTabGroup],
    propertiesList: [{
            "key": "assetId",
            "type": "resourceId",
            "isResourceId": "asset",
            "inputType": "documentAssetId",
            "group": "content",
            "tabGroup": "basic",
            "default": null,
            "title": "asset",
            "description": "The file to be downloaded.",
            "multilingual": true,
        },
        {
            "key": "fileName",
            "type": "string",
            "inputType": "text",
            "group": "content",
            "tabGroup": "basic",
            "default": null,
            "title": "File Name",
            "description": "The name of the file when it is downloaded.",
            "multilingual": true,
        },
        {
            "key": "buttonText",
            "type": "string",
            "inputType": "text",
            "group": "content",
            "tabGroup": "basic",
            "default": null,
            "title": "Button text",
            "description": "The text to show on the download button.",
            "multilingual": true,
        }, {
            "key": "buttonColor",
            "type": "string",
            "inputType": "color",
            "group": "style",
            "tabGroup": "basic",
            "default": "#ED7F50",
            "title": "Button color",
            "description": "The color to use for the download button. Use the color selector or specify a hex value.",
            "multilingual": false,
        }, {
            "key": "darkTextColor",
            "type": "boolean",
            "group": "style",
            "tabGroup": "basic",
            "inputType": "switch",
            "default": true,
            "title": "Dark text color",
            "description": "Use a dark text color for the button text.",
            "multilingual": false,
        }, {
            "key": "invertColors",
            "type": "boolean",
            "group": "style",
            "tabGroup": "basic",
            "inputType": "switch",
            "default": false,
            "title": "Invert colors",
            "description": "Switch the button color and the text color.",
            "multilingual": false,
        }, {
            "key": "icon",
            "type": "list.string",
            "inputType": "iconOption",
            "group": "style",
            "tabGroup": "basic",
            "default": ["arrow-alt-down"],
            "title": "Icon",
            "description": "Icon to show in the button. See <a href='https://fontawesome.com/icons' target='_blank'>Font Awesome</a> for supported icons.",
            "multilingual": false,
        }, {
            "key": "iconClass",
            "type": "string",
            "inputType": "iconClassOption",
            "group": "style",
            "tabGroup": "basic",
            "default": "fal",
            "title": "Icon weight",
            "description": "The weight (light, regular, bold) to use for the icon.",
            "multilingual": false,
        },
        parentElementId,
    ],
});
export const grid = new PostElementType({
    name: "grid",
    icon: ["fal", "th"],
    title: "Grid",
    description: "Grid",
    tabGroups: [basicTabGroup],
    parallelGroups: [{
            group: "projectsGroup",
            title: "Projects",
            description: "The projects that can be chosen and viewed by the visitor.",
            labelPropertyName: "projectIdList",
            tabGroups: [basicTabGroup],
            tabGroup: "basic",
            showIfProperty: {
                "key": "contentType",
                "value": ["ideas", "proposals"],
            },
        }],
    propertiesList: [{
            "key": "contentType",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["posts", "ideas", "proposals"],
            "valueOptionTexts": ["Pages", "Budgeting ideas", "Budgeting proposals"],
            "valueOptionNeedsLicense": [false, "feature:group:projects", "feature:group:projects"],
            "group": "content",
            "tabGroup": "basic",
            "default": "posts",
            "title": "Grid type",
            "description": "The type of items that will be shown in the grid.",
            "multilingual": false,
        }, {
            "key": "projectIdList",
            "type": "list.resourceId",
            "isResourceId": "project",
            "inputType": "projectId",
            "showIfProperty": {
                "key": "contentType",
                "value": ["ideas", "proposals"],
            },
            "group": "projectsGroup",
            "tabGroup": "basic",
            "default": [""],
            "defaultInsert": "",
            "title": "Project",
            "description": "Select a project that will determine which ideas or proposals to show.",
            "multilingual": false,
        }, {
            "key": "tagList",
            "type": "list.string",
            "inputType": "dynamicOption",
            "showIfProperty": {
                "key": "contentType",
                "value": ["posts"],
            },
            "group": "content",
            "tabGroup": "basic",
            "default": [],
            "title": "Select pages by tag",
            "description": "Select a tag that determines which posts are displayed in the grid. You need to add this tag to all pages that you wish to appear. You can use a public tag (with # prefix) or a private tag (no # prefix).",
        }, {
            "key": "projectTitleList",
            "type": "list.string",
            "inputType": "text",
            "group": "projectsGroup",
            "tabGroup": "basic",
            "default": [""],
            "defaultInsert": "",
            "title": "Project title",
            "description": "The title of the project that the visitors will see.",
            "multilingual": false,
        }, {
            "key": "showSearchAndSchedule",
            "type": "boolean",
            "inputType": "switch",
            "group": "content",
            "tabGroup": "basic",
            "default": false,
            "title": "Show search bar and filter options",
            "description": "Add a search bar and filter options.",
        }, {
            "key": "randomize",
            "type": "boolean",
            "inputType": "switch",
            "group": "content",
            "tabGroup": "basic",
            "default": false,
            "title": "Randomize items",
            "description": "Show the items in a random order.",
        }],
});
export const carousel = new PostElementType({
    name: "carousel",
    icon: ["fal", "th"],
    title: "carousel",
    description: "carousel",
    tabGroups: [basicTabGroup],
    propertiesList: [{
            "key": "contentType",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["posts"],
            "valueOptionTexts": ["Pages"],
            "valueOptionNeedsLicense": [false],
            "group": "content",
            "tabGroup": "basic",
            "default": "posts",
            "title": "Carousel type",
            "description": "The type of items that will be shown in the carousel.",
            "multilingual": false,
            "hiddenFromInterface": true,
        }, {
            "key": "projectId",
            "type": "resourceId",
            "isResourceId": "project",
            "inputType": "projectId",
            "showIfProperty": {
                "key": "contentType",
                "value": ["ideas", "proposals"],
            },
            "group": "functional",
            "tabGroup": "basic",
            "default": null,
            "title": "Project",
            "description": "Select a project that will determine the ideas or proposals to show in the map.",
            "multilingual": false,
            "hiddenFromInterface": true,
        }, {
            "key": "tagList",
            "type": "list.string",
            "inputType": "dynamicOption",
            "group": "content",
            "tabGroup": "basic",
            "default": [],
            "title": "Select pages by tag",
            "description": "Select a tag that determines which posts are displayed in the carousel. You need to add this tag to all pages that you wish to appear on the map. You can use a public tag (with # prefix) or a private tag (no # prefix).",
        }, {
            "key": "showSearchAndSchedule",
            "type": "boolean",
            "inputType": "switch",
            "group": "content",
            "tabGroup": "basic",
            "default": false,
            "title": "Show search bar and filter options",
            "description": "Add a search bar and filter options.",
        }, {
            "key": "randomize",
            "type": "boolean",
            "inputType": "switch",
            "group": "content",
            "tabGroup": "basic",
            "default": false,
            "title": "Randomize items",
            "description": "Show the items in the carousel in a random order.",
        }, {
            "key": "singleLine",
            "type": "boolean",
            "inputType": "switch",
            "group": "style",
            "tabGroup": "basic",
            "default": false,
            "title": "Single line",
            "description": "Select this option to only show a single line of items in the carousel.",
        }],
});
export const mapElement = new PostElementType({
    name: "mapElement",
    icon: ["fal", "map-marked-alt"],
    title: "map element",
    description: "map element",
    tabGroups: [basicTabGroup, extraTabGroup],
    isDeprecated: true,
    parallelGroups: [{
            group: "layerGroup",
            title: "Layers",
            description: "Different layers added to the points in the map.",
            labelPropertyName: "layers",
            tabGroups: [basicTabGroup],
            tabGroup: "basic",
        }],
    propertiesList: [{
            "key": "mapCoordinatePicker",
            "type": "object",
            "inputType": "mapCoordinatePicker",
            "group": "content",
            "tabGroup": "basic",
            "default": {},
            "title": "Map location",
            "description": "Set starting coordinates and zoom level for the map",
        }, {
            "key": "contentType",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["posts", "ideas", "proposals"],
            "valueOptionTexts": ["Pages", "Budgeting ideas", "Budgeting proposals"],
            "valueOptionNeedsLicense": [false, "feature:group:projects", "feature:group:projects"],
            "group": "content",
            "tabGroup": "basic",
            "default": "posts",
            "title": "Item type",
            "description": "The type of items that will be shown on the map.",
            "multilingual": false,
        }, {
            "key": "baseMap",
            "type": "list.resourceId",
            "isResourceIdList": "asset",
            "group": "",
            "tabGroup": "basic",
            "assetGroup": "maps",
            "inputType": "assetPicker",
            "default": [],
            "title": "Background map",
            "description": "The background map to show",
            "multilingual": false,
        }, {
            "key": "mapOverlay",
            "type": "list.resourceId",
            "isResourceIdList": "asset",
            "group": "",
            "tabGroup": "basic",
            "assetGroup": "maps",
            "inputType": "assetPickerMany",
            "default": [],
            "title": "Map overlays",
            "description": "Select overlays to show in the map",
            "multilingual": false,
        }, {
            "key": "tagList",
            "type": "list.string",
            "inputType": "dynamicOption",
            "showIfProperty": {
                "key": "contentType",
                "value": ["posts"],
            },
            "group": "content",
            "tabGroup": "basic",
            "default": [],
            "title": "Select pages by tag",
            "description": "Select a tag that determines which posts are displayed on the map. You need to add this tag to all pages that you wish to appear on the map. You can use a public tag (with # prefix) or a private tag (no # prefix).",
        }, {
            "key": "projectId",
            "type": "resourceId",
            "isResourceId": "project",
            "inputType": "projectId",
            "showIfProperty": {
                "key": "contentType",
                "value": ["ideas", "proposals"],
            },
            "group": "functional",
            "tabGroup": "basic",
            "default": null,
            "title": "Project",
            "description": "Select a project that will determine the ideas or proposals to show in the map.",
            "multilingual": false,
        }, {
            "key": "mapHeight",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["small", "medium", "large"],
            "valueOptionTexts": ["Small", "Medium", "Large"],
            "group": "style",
            "tabGroup": "extra",
            "default": "medium",
            "title": "Height",
            "description": "Set height of the map.",
            "multilingual": false,
        }, {
            "key": "mapWidth",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["small", "medium", "large"],
            "valueOptionTexts": ["Small", "Medium", "Large"],
            "group": "style",
            "tabGroup": "extra",
            "default": "medium",
            "title": "Width",
            "description": "Set width of the map.",
            "multilingual": false,
        }, {
            "key": "scaleUnit",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["metric", "imperial"],
            "valueOptionTexts": ["Metric", "Imperial"],
            "group": "style",
            "tabGroup": "extra",
            "default": "metric",
            "title": "Scale unit",
            "description": "Choose which unit to show in the scale line.",
            "multilingual": false,
        }, ...LayerProperties,
        parentElementId,
    ],
});
export const chartElement = new PostElementType({
    name: "chartElement",
    icon: ["fal", "chart-bar"],
    title: "chart element",
    description: "chart element",
    tabGroups: [basicTabGroup],
    propertiesList: [{
            "key": "projectId",
            "type": "resourceId",
            "isResourceId": "project",
            "inputType": "projectId",
            "group": "functional",
            "tabGroup": "basic",
            "default": null,
            "title": "Project",
            "description": "Select a project from which voting results will be shown.",
            "multilingual": false,
        }, {
            "key": "resultFormat",
            "type": "string",
            "inputType": "ownOption",
            "valueOptions": ["votes", "currency", "support"],
            "valueOptionTexts": ["Votes", "Currency", "Support"],
            "group": "functional",
            "tabGroup": "basic",
            "default": "votes",
            "title": "Result format",
            "description": "Select the format of the result to be displayed. Please comeup with better description.",
            "multilingual": false,
        }, {
            "key": "currencyId",
            "type": "resourceId",
            "isResourceId": "currency",
            "inputType": "currencyId",
            "showIfProperty": {
                "key": "resultFormat",
                "value": ["currency", "support"],
            },
            "group": "functional",
            "tabGroup": "basic",
            "default": null,
            "title": "Currency",
            "description": "Select the currency to display in the graph.",
            "multilingual": false,
        },
        parentElementId,
    ],
});
export const elink = new PostElementType({
    name: "elink",
    icon: ["fal", "pager"],
    // icon: ["fal", "external-link-square"],
    title: "External link",
    description: "A link to an external webpage",
    tabGroups: [basicTabGroup],
    propertiesList: [{
            "key": "href",
            "type": "string",
            "inputType": "url",
            "group": "content",
            "tabGroup": "basic",
            "default": "",
            "title": "Iframe URL",
            "description": "The URL of the page that you want to embed.",
            "multilingual": true,
        }, {
            "key": "title",
            "type": "string",
            "inputType": "text",
            "group": "content",
            "tabGroup": "basic",
            "default": null,
            "title": "Title",
            "description": "A title to display above the image.",
            "multilingual": true,
        }, {
            "key": "description",
            "type": "string",
            "inputType": "textarea",
            "native.rows": 4,
            "group": "content",
            "tabGroup": "basic",
            "default": null,
            "title": "Description",
            "description": "A description of the linked website.",
            "multilingual": true,
        }, {
            "key": "imageAssetId",
            "type": "resourceId",
            "isResourceId": "asset",
            "inputType": "imageAssetId",
            "group": "functional",
            "tabGroup": "basic",
            "default": null,
            "title": "Image asset",
            "description": "An asset to use when displaying this image.",
            "multilingual": true,
        },
        parentElementId,
    ],
});
export const elinkGrid = new PostElementType({
    name: "elinkGrid",
    icon: ["fal", "pager"],
    title: "External link grid",
    description: "Grid of external links",
    tabGroups: [basicTabGroup],
    parallelGroups: [{
            group: "linksGroup",
            title: "External link grid",
            description: "Grid of external links. This element is for adding a link that leads outside Maptionnaire. Instead of a hyperlink (link embedded to text), this element includes a title, a description and an image for the links.",
            labelPropertyName: "hrefList",
            tabGroups: [basicTabGroup],
            tabGroup: "basic",
        }],
    propertiesList: [{
            "key": "hrefList",
            "type": "list.string",
            "inputType": "url",
            "group": "linksGroup",
            "tabGroup": "basic",
            "default": [""],
            "defaultInsert": "",
            "title": "Page URL",
            "description": "The URL of the website that you want to link to below (must include http:// or https:// at the start).",
            "multilingual": true,
        }, {
            "key": "titleList",
            "type": "list.string",
            "inputType": "text",
            "group": "linksGroup",
            "tabGroup": "basic",
            "default": [""],
            "defaultInsert": "",
            "title": "Title",
            "description": "A title for the linked webpage.",
            "multilingual": true,
        }, {
            "key": "descriptionList",
            "type": "list.string",
            "inputType": "textarea",
            "native.rows": 4,
            "group": "linksGroup",
            "tabGroup": "basic",
            "default": [""],
            "defaultInsert": "",
            "title": "Description",
            "description": "A description of the linked webpage.",
            "multilingual": true,
        }, {
            "key": "imageAssetIdList",
            "type": "list.resourceId",
            "isResourceId": "asset",
            "inputType": "imageAssetId",
            "group": "linksGroup",
            "tabGroup": "basic",
            "default": [""],
            "defaultInsert": "",
            "title": "Image",
            "description": "Choose (from Materials) or upload an image that you want to show with this link.",
            "multilingual": true,
        }],
});
export const sharingButton = new PostElementType({
    name: "sharingButton",
    icon: ["fal", "share"],
    title: "Sharing button",
    description: "social media sharing",
    tabGroups: [basicTabGroup],
    propertiesList: [{
            "key": "sharingButton",
            "type": "list.string",
            "default": [],
            "group": "functional",
            "inputType": "ownOptionMany",
            "tabGroup": "basic",
            "valueOptions": ["facebook", "twitter", "linkedin", "pinterest", "reddit"],
            "valueOptionIcons": [["fab", "facebook"], ["fab", "x-twitter"], ["fab", "linkedin"], ["fab", "pinterest"], ["fab", "reddit"]],
            "title": "Sharing buttons",
            "description": "Choose the social media sharing buttons that you want to feature on this page. The buttons make it easier for readers to share the page on social media.",
            "multilingual": false,
        },
        parentElementId,
    ],
});
//# sourceMappingURL=postElementType.js.map